import React from "react";
import ReactDOM from "react-dom";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

import App from "./App";

import "normalize.css";
import { config } from "./config";

const promise = loadStripe(`${config.STRIPE_API_KEY}`);

ReactDOM.render(
    <React.StrictMode>
        <Elements stripe={promise}>
            <App />
        </Elements>
    </React.StrictMode>,
    document.getElementById("root")
);
